import React from "react";
import {RouteObject} from "react-router-dom";
import SettingsPageLayout from "../../layout/SettingsPageLayout/SettingsPageLayout";

const SettingsPageRoutes : RouteObject[] = [
    {
        path:'settings',
        element:<SettingsPageLayout/>
    }
]

export default SettingsPageRoutes;